<template>
  <div>
    <nav class="navbar navbar-expand-lg px-5 navbar-custom">
      <ul class="navbar-nav">
        <li>
          <router-link class="navbar-brand c_styles" :to="{ name: 'home' }">
            <!-- <img src="/images/LOGO6.png" alt="" width="30" height="24"> -->
            <img src="/images/fdm-logo-full.png" alt="" width="200" />
            <!-- ЛОГОТИП -->
          </router-link>
        </li>
      </ul>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span>&#9776;</span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-3">
          <li class="nav-item active">
            <router-link class="nav-link" :to="{ name: 'home' }"
              >Главная</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :to="{ name: 'articles' }"
              >Статьи</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              v-if="authenticated"
              class="nav-link"
              :to="{ name: 'courses' }"
              >Курсы</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              v-if="authenticated"
              style="color: white"
              class="nav-link"
              :to="{ name: 'departments' }"
            >
              Кафедры
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              v-if="authenticated"
              style="color: white"
              class="nav-link"
              :to="{ name: 'dashboard' }"
            >
              Профиль
            </router-link>
          </li>
          <li class="nav-item">
            <div class="nav-item dropdown" v-if="authenticated">
              <a
                style="color: white"
                class="nav-link dropdown-toggle c_styles"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Администрирование
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <router-link
                  v-if="user.is_admin"
                  class="dropdown-item"
                  :to="{ name: 'adminDepartments' }"
                  >Кафедры [adm]</router-link
                >
                <router-link
                  v-if="user.is_admin"
                  class="dropdown-item"
                  :to="{ name: 'adminCategories' }"
                  >Категории [adm]</router-link
                >
                <router-link
                  v-if="user.is_admin"
                  class="dropdown-item"
                  :to="{ name: 'adminCourseStates' }"
                  >Состояния курсов [adm]</router-link
                >
                <router-link
                  v-if="user.is_admin"
                  class="dropdown-item"
                  :to="{ name: 'adminChapterStates' }"
                  >Состояния глав [adm]</router-link
                >
                <div 
                  v-if="user.is_admin"
                  class="dropdown-divider">
                </div>
                <router-link
                  class="dropdown-item"
                  :to="{ name: 'adminCourses' }"
                  >Курсы [adm]</router-link
                >
              </div>
            </div>
          </li>
        
        </ul>

        <div class="form-inline ml-auto">
          <button
            v-if="authenticated"
            @click="signOut"
            class="btn btn__primary--outline"
            type="button"
          >
            Выход
          </button>

          <router-link
            class="btn btn__primary--outline"
            v-if="!authenticated"
            :to="{ name: 'signin' }"
            >Вход</router-link
          >
        
          <!-- <button class="btn btn__primary ml-3" type="button">Sign Up</button> -->
        </div>
      </div>
    </nav>


  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace(
          {
            name: "home",
          },
          () => {} // это нужно чтобы не было ексепшена при перенаправлении "с себя на себя", т.е. с home на home.
        );
      });
    },
  },
};
</script>
<style scoped>

/*
    TheNavigation
*/
.navbar-custom {
    color           : var(--color-blue-gray-3);
    background-color: #fff !important;
}

.navbar-custom .nav-link {
    color: var(--color-blue-gray-3) !important;
}

.navbar-toggler {
    border    : 1px solid var(--color-blue-gray-3) !important;
    background: #e3e3e3;
}

.navbar-toggler-icon {
    display          : block;
    /* font-size     : 26px; */
    /* vertical-align: middle; */
    /* background    : #000 !important;
    color            : #fff; */
}


</style>